import { Component, ElementRef, OnChanges, OnInit, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/services/apiService';
import { SweetAlertService } from 'src/services/sweetAlertService';
import { Field } from '../models/field';
import {Container} from '../models/ContainerField';
import { formBody } from '../models/formBody';
import { FileModel } from '../models/file';
import {ConditionType} from '../models/enum/conditionType';
import { AuthService } from 'src/services/auth.service';
import * as _ from 'lodash';
import { Observable, catchError, map, of, tap } from 'rxjs';
import { CalculationComponent } from './fields/calculation/calculation.component';
import { environment } from 'src/environments/environment';
import { SubmitValidation } from '../models/submitValidation';
import { DatePipe } from '@angular/common';

export class FieldInfo{
  filedValue:any|undefined;
  fieldType:string|undefined;


  constructor(filedValue:any,fieldType :string) {
    this.fieldType=fieldType;
    this.filedValue=filedValue;
  }
}


@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.css'],
  encapsulation:ViewEncapsulation.None,
})


export class FormComponent implements OnInit  {

  @ViewChild(CalculationComponent) childComponent!: CalculationComponent;

  fields:Field[];
  mainPath = "" // قراءة القيمة من environment
  SectionIdEnv = ""
  myForm:UntypedFormGroup; 
  files:FileModel[];
  serviceId:string|undefined;
  BluePrintId:string|undefined;
  isLoading=true;
  service:any;
  submitted = false;
  containers:Container[]=[];
  serviceName:string|undefined;
  serviceCard:any;
  yourTurn=false;
  payment=false;
  production=environment.production;
  showSubmit=true;
  textViewItemArr:any[]=[];
  message:string|undefined;
  showStep="1";
  screenName:string|undefined;
  phoneDto:any;
  disableConditionBtn=false;

  viewApplication=false;
  steps:any[]=[];
  stepsName:any[]=[];
  currentIndex=0;

  serviceType:string|undefined;

  applyForServiceBody:any;

  doesFormGenerated=false;

  currentSubmitButtonText:string|undefined;

  submitValidation:SubmitValidation|undefined;

  fieldsHasNote:Field[]=[];

  goToStep2Enable=false;

  onCheckboxChange(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    this.goToStep2Enable = checkbox.checked;
  }

  private scrollToFirstInvalidControl() {
    let firstInvalidControl = $("input.is-invalid,select.is-invalid")[0];
    firstInvalidControl.scrollIntoView();
    (firstInvalidControl as HTMLElement).focus();
  }

  //9861049531
  constructor(private apiService:ApiService,private route: ActivatedRoute, private el: ElementRef,
    private sweetAlertService:SweetAlertService,private authService:AuthService,private fb: FormBuilder,
    private datePipe: DatePipe
    ) {
      this.mainPath= environment.MainPath;
      this.SectionIdEnv= environment.SectionId;

    this.myForm=new UntypedFormGroup({});
    this.files=[];
    this.fields=[];
    
  }


  goStep1(){
    this.showStep="1";
  }

  goStep2(){
    if(this.doesFormGenerated==false){
      this.applyForService(this.applyForServiceBody);
    }
    this.showStep="2";
  }

  disableFormControls(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      control!.disable(); // Disable the control
      control!.markAsUntouched();
      control!.markAsPristine();
      if (control instanceof FormGroup) {
        this.disableFormControls(control); // Recursively disable controls in nested form groups
      }
    });
  }

  
  

  fillApplication(){

    var request=this.apiService.get(`carboncopies/GetServiceByIdForConsumer?serviceId=${this.serviceId}&type=${this.serviceType}`);

    request.subscribe(response=>{

      var data=response.data;
     this.currentSubmitButtonText= "التالي"
      this.serviceName=data.name;

      this.steps = (data.steps as any[]).reverse();

      this.generateField(this.steps[0]?.fields,false);

      this.steps.map(step=>{
        this.stepsName.push(step.name);
      });

      this.onParentChange(this.fields);

      this.disableFormControls(this.myForm);
      this.goStep2();

      this.viewApplication=true;

      this.isLoading=false;

    });
  }

  goNext(){
    
    this.currentIndex<this.steps.length-1? this.currentIndex++:this.currentIndex;
    
    if(this.currentIndex<=this.steps.length-1){

      this.removeFormControls();
    
      this.generateField(this.steps[this.currentIndex]?.fields,false);
  
      this.onParentChange(this.fields);
  
      this.disableFormControls(this.myForm);
  
      this.isLoading=false;
    }
  }

  goBack(){

    this.currentIndex>0? this.currentIndex--:this.currentIndex;

    if(this.currentIndex>=0){

      this.removeFormControls();
      
      this.generateField(this.steps[this.currentIndex]?.fields,false);
  
      this.onParentChange(this.fields);
  
      this.disableFormControls(this.myForm);
  
      this.isLoading=false;
      }
  }


  ngOnInit(): void {


    if (this.route.snapshot.queryParams['serviceId'] && this.route.snapshot.queryParams['showForm']) {

      this.serviceId= this.route.snapshot.queryParams['serviceId'];
      this.serviceType= this.route.snapshot.queryParams['serviceType'];

      this.doesFormGenerated=true;

      this.fillApplication();
    }

    else if (this.route.snapshot.queryParams['BluePrintId']) {

      const bluePrintId = this.route.snapshot.queryParamMap.get('BluePrintId');

      var sectionId = this.route.snapshot.queryParamMap.get('SectionId');

      if(bluePrintId!=null && sectionId!=null){

        this.BluePrintId=bluePrintId;

      }

      var Services=this.apiService.get('categorization/GetServicesWithSectionId?id='+sectionId!);

      Services.subscribe(response=>{
  
        var data=response.data as any[];
  
        var service=data.filter(x=>x.id==this.BluePrintId)[0];

        this.serviceName=service.name;
        this.serviceCard=service.serviceCard;
  
        var rootValues=service.rootValues as any[];
  
          this.applyForServiceBody ={
            "serviceId": this.BluePrintId,
              "rootValues": rootValues.map(x=>{
                return{
                  "fieldId": x.fieldId,
                  "keyValue": x.keyValue,
                  "value":this.authService.getNationalNumber(),
                }
              })
          };

          if(!service.serviceCard.shouldShow){
            //this.isLoading=true;
            this.disableConditionBtn=true;
            this.isLoading=false;
            //this.goStep2();
          }else{
            this.isLoading=false;
          }    
      });

    }
    else if(this.route.snapshot.queryParams['serviceId']){

      this.serviceId = this.route.snapshot.queryParamMap.get('serviceId')!;

      this.yourTurn=true;
      this.disableConditionBtn=true;

      this.doesFormGenerated=true;

      this.goStep2();

      const serviceName = this.route.snapshot.queryParamMap.get('serviceName');

      this.serviceName=serviceName??"-";

      this.GetStepForConsumer();
     
    }


    this.listenToVisibilityChange();

    

    console.log(this.myForm);
    console.log(this.fields);

  }

  private applyForService(body: { serviceId: string | undefined; rootValues: { fieldId: any; keyValue: any; value: string | null; }[]; }) {

    this.isLoading=true;
    
    var request = this.apiService.post("carboncopies/applyforservice", body);
    request.subscribe(res => {

      if (res.statusCode == 200 && res.error == false) {
        this.serviceId = res.data;
        this.GetStepForConsumer();
        this.doesFormGenerated=true;
      }
    });
  }

  deleteContainer(event: any, showConfirmation = true) {
  
    var indexId = event.indexId;
    var containerId = event.containerId;

    if(showConfirmation){
      if (window.confirm("هل انت متأكد ؟")==false) {
        return;
      }
    }
  
    if (true) {
      const filterCondition = indexId
        ? (x: any) => x.containerId === containerId && x.id === indexId
        : (x: any) => x.containerId === containerId;
  
      const indexToDelete = this.containers.findIndex(filterCondition);
  
      const selectedContainer = this.containers.filter(filterCondition)[0];
  
      this.updateValidation();
  
      selectedContainer.containerFields.map((field: any) => {

        if (field.type === "CONTAINER") {
          this.deleteContainer({ containerId: field.id },false);
        }
        this.myForm.removeControl(field.id);

        
        try{
          this.calculate(field.id);
        }catch(ex){

        }
        
      });
  
      this.containers.splice(indexToDelete, 1);
      
      
    }

    
  }
  
  appendQueryString(url: string): string {
    const token = `Token=${this.authService.getToken()}`;

    if (url.includes('?')) {
        if (url.charAt(url.length - 1) === '&') {
            return url + token;
        } else {
            return url + '&' + token;
        }
    } else {
        return url + '?' + token;
    }
  }


  calculate(fieldId:string) {

    const baseId = fieldId.replace(/#.*$/, '');


    var calcFields=this.getCalculationFields();

    const targetCalculation = calcFields.find(x => x.equation?.left.fieldId == baseId || x.equation?.right.fieldId == baseId);

    if (!targetCalculation) return;

    const targetValueControl = this.myForm?.get(targetCalculation.id);

    let accumulatedValue: number = 0;

    const controlValue = Number(this.myForm?.get(targetCalculation.equation?.left.fieldId)?.value??0);

    const otherControlValue = Number(this.myForm?.get(targetCalculation.equation?.right.fieldId)?.value??0);

    if (targetCalculation.equation?.operation === "PLUS") {
        accumulatedValue = controlValue + otherControlValue;
    } else {
        accumulatedValue = controlValue - otherControlValue;
    }

    targetValueControl?.setValue(accumulatedValue);
  }
  
  addContainerItems(event:any){


    if(event.field.sizeLimit!=null){

      var maxContainer=this.myForm.get(event.field.sizeLimit)?.value;


      if(this.containers.filter(x=>x.containerId==event.field.id).length>=maxContainer && maxContainer!=null){
        this.sweetAlertService.ShowAlert('error','وصلت الى الحد الاقصى');
        return;
      }

    }

    var container=event.field as Field;

    var updatedFields=this.updateContainerIds(_.cloneDeep(container));

    this.containers.push(new Container(this.containers.length+1,updatedFields.id,updatedFields.fields!,1,updatedFields.designType));

    updatedFields.fields?.map(field=>{

      field.value=null;
      
      this.addField(field,field.id,'');

    });

    this.myForm.addControl(container.id, new FormControl(null));


  }


  GetStepForConsumer(){
    
    var request=this.apiService.get(`carboncopies/GetStepForConsumer?serviceId=${this.serviceId}`)
    request.subscribe(res=>{

      if(res.statusCode==200){
        
        this.currentSubmitButtonText=res.data.submitButtonText; 

        this.submitValidation=res.data?.submitValidation;

        this.screenName=res.data?.name;

        this.generateField(res.data.fields,false);

        this.onParentChange(this.fields);
      }else{
        this.showSubmit=false;
      }

      this.isLoading=false;


    });


  }

  private generateField(fields: Field[], refresh: boolean): void {

    this.fieldsHasNote=fields.filter(x=>x.comment!=null);

    const backupFields = (field: Field) => {
        field.oldRequired = field.required;
        field.oldEditable = field.editable;
        field.oldHidden = field.hidden;
        field.oldModifiable = field.modifiable;
    };

    fields.forEach(field => {
        backupFields(field);
        if (field.type === "CONTAINER" && field.fields) {
            field.fields.forEach(backupFields);
        }
        
        this.fields.push(field);
        this.addField(field, field.id, field.value);
    });
  }

  private addField(field: Field,fieldId:string,value:any) {

    if (field.type == 'CHECBOX') {
      this.generateCheckbox(field,fieldId,value);
    }
    else if (field.type == 'PREDEFINED_COMBO_BOX') {
      this.generatePredefinedComboBox(field,fieldId,value);
    }
    else if (field.type == 'COMBO_BOX') {
      this.generateComboBox(field,fieldId,value);
    }
    else if ((field.type == 'TEXT_FIELD' && field.textFieldType=="date" )|| field.type=="DATE") {
      this.generateDate(field,fieldId,value);
    }
    else if (field.type == 'TEXT_FIELD') {
      this.generateTextField(field,fieldId,value);
    }
    else if (field.type == 'FILE') {
      this.generateFile(field,fieldId,value);
    }
    else if (field.type == 'EFAWATEERCOM') {

      this.generateEfawateercom(field);

    }
    else if (field.type == 'CONTAINER') {

      this.generateContainerV2(field,field.value);

    }
    else if (field.type == 'TEXT_FIELD_PHONE') {

      this.generateOther(field,fieldId,value);

    }
    else if (field.type == "COPY_WIDGET") {

      this.generateCopyWidget(field,fieldId,value);

    }
    else if (field.type == 'WEBVIEW') {

      //this.showSubmit=false;
      this.generateOther(field,fieldId,field.url);

    }
    else {
      this.generateOther(field,fieldId,value);
    }

  }



  generateContainerV2(container: Field,containerValue:any) {

    const containerValues = containerValue as any[] || [];

    const loops = containerValues.length > 0 ? containerValues.length : 1;

    for (let i = 0; i < loops; i++) {
      var updatedContainer= this.updateContainerIds(container);

      this.containers.push(new Container(this.containers.length+1,updatedContainer.id,updatedContainer.fields!,1,updatedContainer.designType));

      const currentLoopValue = containerValues[i] as any[] || [];

      updatedContainer.fields?.map(field=>{

        
        //field.options=

        const newFieldId = this.getBaisFieldName(field);

        const value = currentLoopValue.find((value) => value.fieldId === newFieldId)?.value || null;
        const options = currentLoopValue.find((value) => value.fieldId === newFieldId)?.options as any[] || [];

        if(options.length>0){
          field.comboBoxOptions=options;
        }
      
        if(field.type=="CONTAINER"){
          this.generateContainerV2(field,value);
        }else{
          this.addField(field,field.id,value??"");
        }

      });
  
      this.myForm.addControl(updatedContainer.id, new FormControl(null));

    }
  }


  getBaisFieldName(field:Field):string{
    const index = field.id.indexOf("#");
    const newFieldId = index !== -1 ? field.id.slice(0, index) : field.id; 

    return newFieldId;
  }

  updateContainerIds(container:Field): Field {

    const clonedContainer = _.cloneDeep(container); 

    clonedContainer.fields?.map(field=>{

      var randomText = Math.floor(Math.random() * 10000000000000).toString();

      var newId =field.id+"#"+randomText;

      clonedContainer.fields?.forEach(pf => {
        if (pf.parent) {
          this.updateFieldIdInCondition(pf.parent.condition, field.id, newId);
        }
      });

      field.id=newId;


      if(field.fields){
        this.updateContainerIds(field);
      }

    });

    return clonedContainer;

  }

  
  updateFieldIdInCondition(condition: any, oldId: string, newId: string) {
    if (condition) {
      if (condition.type === "OPERATION") {
        // Recursively update left and right sides
        this.updateFieldIdInCondition(condition.left, oldId, newId);
        this.updateFieldIdInCondition(condition.right, oldId, newId);
      } else if (condition.type === "UI" && condition.fieldId === oldId) {
        // Update the fieldId if it matches
        condition.fieldId = newId;
      }
    }
  }

  getCalculationFields():Field[]{
    var fields=this.fields.filter(x=>x.type=="CALCULATION");

    return fields;
  }


  private generateEfawateercom(field: Field) {
    var fields = field.fields!;

    this.payment = true;
    this.disableConditionBtn=true;
    this.goStep2();

    this.myForm.addControl(field.id, new FormControl(field.value ?? ""));

    fields.forEach(field => {

      this.myForm.addControl(field.id, new FormControl(field.value ?? ""));

    });

  }

  private generateFile(field: Field, fieldId: string, value: string | any[] | null) {
    this.myForm.addControl(fieldId, new FormControl());

    if (value != null) {
        // Check if value is a string and convert it to an array of strings
        if (typeof value === 'string' && value!='') {
            value = [value];
        }

        // Since value is now guaranteed to be an array, we can continue processing
        var files = value as any[];

        if (files.length > 0) {
            files.map(file => {
                this.pubshFile(fieldId, file, "", file);
            });
        }
    }
  }


  private generateComboBox(field: Field,fieldId:string,value:any) {
    this.myForm.addControl(fieldId, new FormControl(value ?? null));
  }

  private generateTextField(field: Field,fieldId:string,value:any) {

    this.myForm.addControl(fieldId, new FormControl(value ?? null));
  }

  private isEditable(field: any): boolean {
  return field?.editable !== false;
}

  private generateCopyWidget(field: Field, fieldId: string, value: any) {

  // Prevent crashes if backend sends invalid COPY_WIDGET
  if (!field.ui) {

    console.error('COPY_WIDGET ui is null', field);

    // still create empty control so form structure stays valid
    this.myForm.addControl(fieldId, new FormControl(null));

    return;
  }

   field.ui.editable = field.editable;

  this.myForm.addControl(
    fieldId,
    new FormControl(field.ui.value ?? null)
  );

  this.addField(
    field.ui,
    field.ui.id,
    field.ui.value
  );
}

  private generateOther(field: Field,fieldId:string,value:any) {

    this.myForm.addControl(fieldId, new FormControl(value ?? null));
  }

  generateDate(field: any, fieldId: string, value: string) {
    let formattedValue = "";

    const dateFormatRegex = /^\d{4}\/\d{2}\/\d{2}$/;
        
    if (dateFormatRegex.test(value)) {
      formattedValue=value;
    }else{
            
      // A helper function to try different date formats
      const parseDate = (dateStr: string): Date | null => {
        // Try ISO format first (yyyy-mm-dd)
        let date = new Date(dateStr);
        if (!isNaN(date.getTime())) {
          return date;
        }

        // Try dd/mm/yyyy format
        const parts = dateStr.match(/(\d{1,2})\/(\d{1,2})\/(\d{4})/);
        const dateFormatRegex = /^\d{4}\/\d{2}\/\d{2}$/;

        if (parts) {
          date = new Date(+parts[3], +parts[2] - 1, +parts[1]);
          if (!isNaN(date.getTime())) {
            return date;
          }
        }

        // Add additional date format checks if necessary

        return null; // If no format matches
      };

      // Check if value is not null or empty
      if (value) {
        const dateObject = parseDate(value);

        // If a valid date object is returned
        if (dateObject) {
          // Extract the date components
          const year = dateObject.getFullYear();
          const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
          const day = dateObject.getDate().toString().padStart(2, '0');
          formattedValue = `${year}-${month}-${day}`;
        } else {
          console.error('Invalid date format:', value);
        }
      }

    }
  
    
  
    
  
    // Assuming this.myForm is already defined and is of a type that has addControl method
    this.myForm.addControl(fieldId, new FormControl(formattedValue));
  }
  
  

 private generatePredefinedComboBox(field: Field, fieldId: string, value: any) {

  const control = new FormControl(value ?? null);

  if (!this.isEditable(field)) {
    control.disable();
  }

  this.myForm.addControl(fieldId, control);
}

  private generateCheckbox(field: Field,fieldId:string,value:any) {
    this.myForm.addControl(fieldId, new FormControl(Boolean(value)));
  }

  downloadMinioFile(objectId:string){

    var request=this.apiService.minioRedirectFile(objectId);
  }
  

  getSubmitValidationStatus(cond:SubmitValidation):boolean{
    var condition  = this.getConditionType(cond.condition) as boolean;

    if(condition){
      this.sweetAlertService.ShowAlert('error',cond.validationMessage??cond.validationMessageTranslations);
      return condition;
    }else{
      if(cond.elseCondition){
        return this.getSubmitValidationStatus(cond.elseCondition);
      }
    }

    return false;

  }

  Save() {

    this.submitted = true;

    //this.route.snapshot.queryParams['serviceId'] && 

    
    if(this.payment==true){
      var body={
        "serviceId": this.serviceId,
        "status": true
      }

      var request=this.apiService.post('carboncopies/CompletePaymentProcess', body);

      request.subscribe(res=>{
        if(res.statusCode==200){
          this.sweetAlertService.ShowAlertThenRedirect('success', res.message ?? "paymet success", '/'+this.mainPath+'/Dashboard');
        }
      });

      return;

    }
    
    if (this.myForm.valid) {

      if(this.submitValidation){
        var submitValidation= this.getSubmitValidationStatus(this.submitValidation);

        if(submitValidation){
          return;
        }

      }
      
      const formValues = this.getFormValues();
  
      const body = {
        userId: this.authService.getNationalNumber(),
        serviceId: `${this.serviceId}`,
        values: formValues,
      };

      this.apiService.post('carboncopies/PostDataForConsumer', body)
        .subscribe(response => {
          const data = response.data;
  
          if (response.statusCode === 200) {
            this.isLoading = false;
            this.showSubmit=true;

  
            if (data.continue === false) {
            
              this.message=response.message;
              //$("#exampleModalBtn").click();

              this.sweetAlertService.ShowAlertThenRedirect('success', response.message, '/'+this.mainPath+'/Dashboard');
            } else {
              this.submitted=false;
              this.removeFormControls();
              this.GetStepForConsumer();
            }
          }
          else{

            this.isLoading = false;
            //this.showSubmit=false;

            //this.sweetAlertService.ShowAlert('error',response.message);

          }
        });
    } else {      

      console.log(this.myForm);
      console.log(this.fields);

      this.myForm.markAllAsTouched();
      
      setTimeout(() => {
        try{
          this.scrollToFirstInvalidControl();

        }catch(ex){

        }
      }, 200);

      console.log(this.myForm);
    }
  }

  updateValidation(): void {
    Object.keys(this.myForm.controls).forEach(controlName => {
      const control = this.myForm.controls[controlName];
      control.markAsUntouched();
      control.updateValueAndValidity();
      control.markAsUntouched();
    });
  }

  validateCheckbox(control: AbstractControl): ValidationErrors | null {

    if (control.value === true) {
    
      return null; // Checkbox is checked, no error
    } else {
      return { checkboxRequired: true }; // Checkbox is not checked, return an error
    }
  }

  hasRequiredValidator(controlName: string): boolean {
    const control = this.myForm.get(controlName);
    if (control) {
      const validators = control.validator && control.validator({} as AbstractControl);
      return validators ? validators.hasOwnProperty('required') : false;
    }
    return false;
  }

  getFormControl(fieldId: string): FormControl | null {
    const control = this.myForm.get(fieldId);
    if (control instanceof FormControl) {
      return control;
    }
    return null;
  }

  getFormControlErrors(fieldId: string): ValidationErrors {
    const control = this.myForm.get(fieldId);
    return control?.errors!;
  }

  getFormControlValidation(fieldId: string): boolean {
    const control = this.myForm.get(fieldId);
    return control?.invalid!;
  }

  
  getFormValues(): formBody[] {
    const formValues: formBody[] = [];
    const controls = this.myForm.controls;
  
    Object.keys(controls).forEach(key => {
      if (!/#\d+$/.test(key)) {
        const field = this.fields.find(x => x.id === key);
  
        if (field) {
          const controlValue = this.getControlValue(field);

if (controlValue) {
  formValues.push(
    new formBody(
      controlValue.fieldType!,
      key,
      controlValue.filedValue ?? ''
    )
  );
}
        }
      }
    });
  
    return formValues;
  }

  formatDate(dateString: string): string {
  
    // Split the date string into parts (assuming format is "DD/MM/YYYY")
    const parts = dateString.split('/');
    if (parts.length !== 3) return ''; // Return empty if invalid format
  
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // Month is 0-based in JS
    const year = parseInt(parts[2], 10);
  
    // Create a valid Date object
    const dateObj = new Date(year, month, day);
  
    // Ensure the Date object is valid
    if (isNaN(dateObj.getTime())) {
      return '';
    }
      // Use DatePipe to format the date correctly
    return this.datePipe.transform(dateObj, 'yyyy-MM-dd')!;
  }
  
  
  getControlValue(field: Field): FieldInfo {

    const control = this.myForm.get(field.id);
    let controlValue = null;

    var fieldType="STRING";
  
    switch (field.type) {

      case 'TEXT_FIELD':

        controlValue = String(control!.value);

        if(field.textFieldType=="date" && controlValue!="" && controlValue!=null){

          const dateFormatRegex = /^\d{4}\/\d{2}\/\d{2}$/;
        
          if (!dateFormatRegex.test(control!.value)) {
            let date = new Date(control!.value);

            // Helper function to add leading zeros
            const zeroPad = (num: number, places: number) => String(num).padStart(places, '0');
  
            // Format the date as dd/MM/yyyy
            let formattedDate = `${zeroPad(date.getDate(), 2)}/${zeroPad(date.getMonth() + 1, 2)}/${date.getFullYear()}`;
  
            if(formattedDate=='NaN/NaN/NaN'){
              controlValue='';
            }else{
              controlValue = this.formatDate(formattedDate);          
            }
          }
  
         }

        break;

      case 'CALCULATION':
        controlValue = String(control!.value);
        break;

   

         case 'COPY_WIDGET':

  fieldType = "COPY_WIDGET";

  const copyWidgetValue = this.getCopyWidgetValue(field.id);

  if (!copyWidgetValue) {
    controlValue = null;
  } else {
    controlValue = copyWidgetValue;
  }

break;

        break;

      case 'TEXT_FIELD_PHONE':

        var phone=control!.value as any;

        if(phone!=null){
          this.phoneDto=phone;
          controlValue = String(phone.e164Number);
        }else{
          controlValue="";
        }

        break; 

      case 'MULTI_COMBO_BOX':

        controlValue = control!.value as any[];

        fieldType="LIST_OF_STRING";

        break;

      case 'MULTI_PREDEFINED_COMBO_BOX':

        controlValue = control!.value as any[];

        fieldType="LIST_OF_STRING";

        break;

      case 'FILE':

        controlValue = this.getFileValue(field.id) as any[]|null;

        fieldType="FILE";

        break;
      case 'CHECKBOX':

        controlValue = this.checkCbValue(field.id);
        fieldType="BOOLEAN";

        break;
      
        case 'WEBVIEW':

        controlValue = field.url;

        break;
      case 'CONTAINER':

        controlValue = this.getContainerValue(field);
        fieldType="CONTAINER";

        break;

      default:
        controlValue = control!.value;
    }
  
    return new FieldInfo(controlValue,fieldType);
  }
  
  getFileValue(fieldId: string): string[] {
    const filesBase64: string[] = this.files
      .filter(file => file.controlName === fieldId)
      .map(file => file.objectId);
  
    return filesBase64;
  }

  setPhoneObject(phoneObj:any){
  }

  goToUrl(url:string){
    window.open(url, '_blank');
  }

 getCopyWidgetValue(fieldId: string): formBody | null {

  const filed = this.fields.find(x => x.id == fieldId);

  if (!filed || !filed.ui) {

    console.error('COPY_WIDGET ui is null during submit', filed);

    return null;
  }

  const fieldData = this.getControlValue(filed.ui);

  return new formBody(
    fieldData.fieldType!,
    filed.ui.id,
    fieldData.filedValue
  );
}
  
  getContainerValue(field: Field): formBody[][] {
    const containerItems = this.containers.filter(x => x.containerId === field.id);
    const containerValue: formBody[][] = [];
  
    containerItems.forEach(containerItem => {
      const fields: formBody[] = [];
  
      containerItem.containerFields.forEach(field => {
        var formField = this.myForm.get(`${field.id}`);

        let fieldType = this.getFieldType(field.type);
  
        let fieldValue: any;
  
        switch (field.type) {
            case 'MULTI_COMBO_BOX':

            fieldType = "LIST_OF_STRING";

            if (typeof formField?.value === 'string') {
              // Split by comma or wrap in array if you expect single value
              fieldValue = [formField.value]; // or formField.value.split(',') if comma-separated
            } else if (Array.isArray(formField?.value)) {
              fieldValue = formField.value;
            } else {
              fieldValue = []; // fallback
            }

            break;

          case 'CONTAINER':

          fieldType = "CONTAINER";
          fieldValue=this.getContainerValue(field);

          break;

          case 'TEXT_FIELD':

          console.log(formField?.value);

          fieldValue = String(formField?.value);
  
          if(field.textFieldType=="date"){

            const dateFormatRegex = /^\d{4}\/\d{2}\/\d{2}$/;
        
            if (!dateFormatRegex.test(formField?.value)) {

              let date = new Date(formField?.value);

              const zeroPad = (num: number, places: number) => String(num).padStart(places, '0');
  
              let formattedDate = `${zeroPad(date.getDate(), 2)}/${zeroPad(date.getMonth() + 1, 2)}/${date.getFullYear()}`;
  
              if(formattedDate=='NaN/NaN/NaN'){
                fieldValue='';
              }else{
                fieldValue = this.formatDate(formattedDate);          
              }
            }
            
          }
  
          break;

           case 'TEXT_FIELD_PHONE':
            

            var phone=formField?.value as any;

            //console.log(phone);
    
            if(phone!=null){
              this.phoneDto=phone;
              fieldValue = String(phone.e164Number);
            }else{
              fieldValue="";
            }
    
            break;
              
          case 'CHECKBOX':
            fieldType = "BOOLEAN";
            fieldValue = this.checkCbValue(field.id);
            break;
          case 'FILE':
            fieldType = "FILE";
            fieldValue = this.getFileValue(`${field.id}`);
            break;
          // Add more cases for other field types if needed
          default:
            fieldValue = formField?.value;
        }
  
        const newFieldId = this.getBaisFieldName(field);

        fields.push(new formBody(fieldType, newFieldId, fieldValue));
      });
  
      containerValue.push([...fields]);
    });
  
    return containerValue;
  }  

  getFieldType(basicType:string):string{

    
    switch (basicType) {

      case 'TEXT_FIELD':

        return 'STRING';

      case 'MULTI_COMBO_BOX':

        return "LIST_OF_STRING";

      case 'FILE':

        return "FILE";

      case 'CHECKBOX':

        return "BOOLEAN";

      case 'CONTAINER':

        return "CONTAINER";

      default:

        return 'STRING';

    }
  }

  private removeFormControls() {
    Object.keys(this.myForm.controls).forEach(controlName => {
      this.isLoading = true;
      this.fields = [];
      this.myForm.removeControl(controlName);
    });

    this.containers=[];
    this.files=[];

  }


  checkCbValue(key:string):boolean{

    if(this.myForm.get(key)?.value ==null || this.myForm.get(key)?.value ==''){
      return false;
    }else{
      return true;
    }

  }

  listenToVisibilityChange() {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        var webViewField=this.fields.filter(x=>x.type=="WEBVIEW")[0];

        if(webViewField){

          var body={
            fieldId:webViewField.id,
            shouldRefresh:true,
            isContainer:false,
            containerFieldId:undefined,
            fieldIndex:undefined
          }

          this.refreshForm(body);

        }
      }
    });

  }

  refreshForm(event:any): void {
    
    if (event.shouldRefresh) {
      this.isLoading = true;
  
      const formValues = this.getFormValues();
  
      const filteredFormValues = formValues.filter(x => x.value !== null && x.value !== undefined && x.value !== "null");
  
      if(event?.fieldId){

        const index = event?.fieldId.indexOf("#");
        const newFieldId = index !== -1 ? event?.fieldId.slice(0, index) : event?.fieldId; 

        event.fieldId = newFieldId;
      }

      const body = {
        userId: this.authService.getNationalNumber(),
        serviceId: this.serviceId,
        fieldId: event.isContainer==true? event.containerFieldId :event.fieldId,
        containerFieldId : event.isContainer==true ? event.fieldId :undefined ,
        fieldIndex:event.fieldIndex!=undefined?event.fieldIndex:null,
        values: filteredFormValues,
      };
  
      this.apiService.post('carboncopies/RefreshStep', body).pipe(
        tap((res: any) => {

          if (res.statusCode === 200) {
            this.showSubmit = true;
            this.removeFormControls();
            this.generateField(res.data.fields, true);
          }
          else if(res.statusCode === 400){
            this.sweetAlertService.ShowAlert('error',res.message);
            this.showSubmit = false;
          }
          else {
            this.showSubmit = false;
          }
        }),
        catchError((error: any) => {
          return of(null); // Handle the error and return a new observable
        })
      ).subscribe(
        (res: any) => {
          this.isLoading = false;
          this.onParentChange(this.fields);
        },
        (error: any) => {
          // This will be executed only if catchError doesn't handle the error
          this.isLoading = false;
        }
      );
    } else {
      this.onParentChange(this.fields);
    }


  }

  
  onParentChange(fields:Field[],doContainer:boolean=true): void {


    this.updateValidation();


    
    fields.filter((field) => field.parent != null).map((field) => {
      
      const data = this.getConditionType(field.parent!.condition);


      if (data === true) {
        field.hidden = field.parent?.hidden;
        field.required = field.parent?.required!;
        field.editable = field.parent?.editable;

        if(field.type=="CONTAINER"){
          field.modifiable=field.parent?.editable;
        }
        
      } else {
        field.hidden = field.oldHidden;
        field.required = field.oldRequired!;
        field.editable = field.oldEditable!;

        if(field.type=="CONTAINER"){
          field.modifiable = field.oldModifiable!;
        }

      }

      if (field.type === 'COPY_WIDGET' && field.ui) {
        field.ui.hidden = field.hidden;
        field.ui.required = field.required;
      }

      if(field.type!="TEXT_FIELD"){
        if( field.editable ==false){
          this.myForm.get(field.id)?.disable();
        }else if(field.editable ==true){
          this.myForm.get(field.id)?.enable();
        }
  
      }
   


    });


    if(doContainer){
      this.containers.map(container=>{
        if(container.designType!="TABLE"){
          this.onParentChange(container.containerFields,false);
        }
      });
    }

  }

  
  getConditionType(condition: any): any {

    switch (condition.type) {
      case ConditionType.Operation:
        return this.conditionLogicOperation(condition);
      case ConditionType.Input:
        return this.inputLogicOperation(condition);
      case ConditionType.UI:
        return this.uiLogicOperation(condition);
      default:
        return false;
    }
  }

  conditionLogicOperation(data:any):boolean{

    var right=this.getConditionType(data.right);
    var left=this.getConditionType(data.left);

    switch (data.operation) {
      case "AND":
        return right && left;
      case "OR":
        return right || left;
      case "EQUAL":

        return right == left;

      case "NOT_EQUAL":
        
      return right != left;

      case "GREATER_THAN":
          return left >= right;
        case "GREATER":
          return left > right;
        case "LESS_THAN":
          return left <= right;
        case "LESS":
          return left < right;

        case "CONTAINS":

          var lestString= left as string;

          var rightString= right as string;
        
          return containsString(lestString,rightString);
          
      default:
        return false;
    }

    function containsString(str1: string, str2: string): boolean {

      if(
        str1!="" && str1!= null &&
        str2!="" && str2!= null
      ){
        return str1.includes(str2);
      }else{
        return false;
      }


    }

  }



  inputLogicOperation(conditionLogicInput:any):any{

    switch (conditionLogicInput.inputType) {
      case "integer":
        return parseInt(conditionLogicInput.input);
      case "number":
        return parseFloat(conditionLogicInput.input);
      case "boolean":
        return conditionLogicInput.input.toLowerCase() === 'true';
      case "string":
        return conditionLogicInput.input;
      default:
        return conditionLogicInput.input;
    }

  }

  uiLogicOperation(conditionLogicUI: any): any {
    const fieldId = conditionLogicUI.fieldId!;
    let control = this.myForm.get(fieldId);

    if (!control) {
      const controls = this.myForm.controls;
      for (const key in controls) {
        if (controls.hasOwnProperty(key) && key.startsWith(fieldId)) {
          control = this.myForm.get(key);
          break;
        }
      }
    }

    const controlValue = control?.value;
    if (controlValue !== undefined && controlValue !== null && controlValue !== '') {
      return controlValue;
    }

    const copyWidgetField = this.fields.find((f) => f.id === fieldId);
    if (copyWidgetField?.type === 'COPY_WIDGET' && copyWidgetField.ui) {
      const nestedControl = this.myForm.get(copyWidgetField.ui.id);
      if (nestedControl?.value !== undefined && nestedControl?.value !== null && nestedControl?.value !== '') {
        return nestedControl.value;
      }
      return copyWidgetField.ui.value;
    }

    return controlValue;
  }

  GetContainerItems(containerId:string):Container[]{

    var container=this.containers.filter(x=>x.containerId==containerId);

    return container;
  }

  onUploadFile(event:any) {

    this.showSubmit=false;

    var controlName=event.fieldId;
    var event=event.event;
    var multi=event.multi as boolean;

    if (multi === false && this.getFiles(controlName).length > 0) {
      this.sweetAlertService.ShowAlert('error', 'you can upload 1 file only');
      return;
    }


    var files=event.target.files as any[];

    for(var i=0;i<files.length;i++){

      this.uploadFileAndGetObjectName(files[i]).subscribe(response=>{
        

        var objectName: string = response;

        this.showSubmit=true;


        if(objectName==null || objectName=="" ){
          this.sweetAlertService.ShowAlert('error','نوع الملف غير مدعوم. يرجى رفع صورة او ملف بصيغة PDF');
         // this.sweetAlertService.ShowAlert('error','يرجى تحميل الملف مرة اخرى');
          return;
        }

        this.pubshFile(controlName, "", "", objectName);

        // const reader = new FileReader();
        // const file = event.target.files[0];
        // reader.readAsDataURL(file);
      
        // reader.onload = () => {
        //   const base64String = reader.result as string;
        //   const base64WithoutPrefix = base64String?.substring(base64String.indexOf(',') + 1);
        //   this.pubshFile(controlName, base64WithoutPrefix, file, objectName);
        // };

      });

    }

    event.target.value = '';

  }
  
  // async uploadFileAndGetObjectName(file: any): Promise<string> {
  //   return new Promise<string>((resolve, reject) => {
  //     this.apiService.uploadFile(file, this.serviceId!).subscribe(
  //       (response: any) => {
  //         const objectName = response.data.objectName;
  //         resolve(objectName);
  //       },
  //       (error: any) => {
  //         return "";
  //       }
  //     );
  //   });
  // }
  
  uploadFileAndGetObjectName(file: any): Observable<string> {
    return this.apiService.uploadFile(file, this.serviceId!).pipe(
      map((response: any) => response.data.path)
    );
  }

  private pubshFile(controlName: string, base64WithoutPrefix: string, fileName: string,objectName:string) {
    this.files.push(new FileModel(this.files.length + 1, controlName, base64WithoutPrefix, fileName,objectName));
  }

  getFiles(controlName:string):FileModel[]{
    return this.files.filter(x=>x.controlName==controlName);
  }

  getAllFiles():FileModel[]{
    return this.files;
  }

  deleteFile(event:any){

    var fileId=event.fieldId;

    if (window.confirm("هل انت متأكد ؟")) {

      var fieldName=this.files.filter(x=>x.id==fileId)[0];

      this.myForm.get(fieldName.controlName)?.setValue(null);

      this.files=this.files.filter(x=>x.id!=fileId);

    }
  }

}